import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import IncompleteCardModal from "./IncompleteCardModal";
import VpnWarningBanner from "./VpnWarningBanner";

const ProtectedRoute = () => {
  const { isLoading, data, isError } = useAuth();

  if (isLoading) return null;

  if (isError || !data?.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <VpnWarningBanner />
      <IncompleteCardModal />
      <Outlet />
    </>
  );
};

export default ProtectedRoute;
